var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-Loader",class:_vm.CSSClasses},[_c('div',{staticClass:"c-Loader__Icon"})])}
var staticRenderFns = []

export { render, staticRenderFns }